var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-container" }, [
      _c("div", {}, [
        _c("button", {
          staticClass: "delete is-pulled-right top5 right5",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        }),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", {
          staticClass: "theMessage",
          domProps: { innerHTML: _vm._s(_vm.message) }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "body-bott has-text-centered" }, [
          _c(
            "button",
            {
              staticClass: "button is-yell",
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_vm._v("\n                        OK\n                ")]
          )
        ]),
        _vm._v(" "),
        _c("br")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5b72c9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5b72c9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalOK.vue
// module id = null
// module chunks = 